import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/auth";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import Login from "@/pages/Login";
import Trunks from "@/pages/Trunks";
import Settings from "@/pages/Settings";
import WorkerKeys from "@/pages/WorkerKeys";
import Agents from "@/pages/Agents";
import AgentDesigner from "@/pages/AgentDesigner";
import Numbers from "@/pages/Numbers";
import Contacts from "@/pages/Contacts";
import Campaigns from "@/pages/Campaigns";
import CampaignDesigner from "@/pages/CampaignDesigner";
import CampaignControl from "@/pages/CampaignControl";
import Dashboard from "@/pages/Dashboard";
import Calls from "@/pages/Calls";
import CallDetail from "@/pages/CallDetail";
import AuditLog from "@/pages/AuditLog";
import "@/App.css";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            element={
              <ProtectedRoute>
                <AppLayout />
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<Navigate to="/trunks" replace />} />
            <Route path="/trunks" element={<Trunks />} />
            <Route path="/agents" element={<Agents />} />
            <Route path="/agents/new" element={<AgentDesigner />} />
            <Route path="/agents/:id" element={<AgentDesigner />} />
            <Route path="/numbers" element={<Numbers />} />
            <Route path="/contacts" element={<Contacts />} />
            <Route path="/campaigns" element={<Campaigns />} />
            <Route path="/campaigns/new" element={<CampaignDesigner />} />
            <Route path="/campaigns/:id" element={<CampaignDesigner />} />
            <Route path="/campaigns/:id/control" element={<CampaignControl />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/calls" element={<Calls />} />
            <Route path="/calls/:job_id" element={<CallDetail />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/worker-keys" element={<WorkerKeys />} />
            <Route path="/audit" element={<AuditLog />} />
          </Route>
          <Route path="*" element={<Navigate to="/trunks" replace />} />
        </Routes>
        <Toaster richColors closeButton position="top-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
